<template>
  <div class="card" style="max-width:420px;margin:40px auto;padding:20px;">
    <h2 style="margin:0 0 10px 0;text-align:center;">Login</h2>
    <p style="color:var(--muted); margin-top:0;">Sign in with your account manager credentials.</p>
    <form @submit.prevent="login">
      <div style="margin-bottom:12px;">
        <div class="label">Email</div>
        <input v-model="email" type="email" class="input" placeholder="you@example.com" required />
      </div>
      <div style="margin-bottom:16px;">
        <div class="label">Password</div>
        <input v-model="password" type="password" class="input" placeholder="••••••••" required />
      </div>
      <button class="btn" type="submit" style="width:100%" :disabled="loading">
        <span v-if="loading">Signing in...</span>
        <span v-else>Sign in</span>
      </button>
    </form>
    <div v-if="error" style="margin-top:12px; color:#fca5a5;">{{ error }}</div>
  </div>
</template>

<script>
import { auth } from '@/services/auth'
export default {
  name: 'AffiliateLogin',
  data() {
    return {
      email: '',
      password: '',
      loading: false,
      error: ''
    }
  },
  methods: {
    async login() {
      this.error = ''
      this.loading = true
      try {
        await auth.login(this.email, this.password)
        this.$router.push('/dashboard')
      } catch (e) {
        this.error = e?.response?.data?.message || e.message || 'Login failed'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
